import {
  ApiCartChangeCartContactFailedAction,
  ApiCartChangeCartContactSucceededAction,
  apiCartChangeCartContactFailedType,
  apiCartChangeCartContactRequested,
  apiCartChangeCartContactSucceededType
} from '../../api/cart/changeCartContactApi';
import {
  ChangeCurrentCartContactRequestedAction,
  changeCurrentCartContactFailed,
  changeCurrentCartContactSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartContactResult } from '../../../graphql/cart/changeCartContact';
import { CustomOrderType } from '../../carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartContactSaga({
  payload: { actionId: requestedActionId, contact, customOrderType }
}: ChangeCurrentCartContactRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartContactRequested({
      actionId,
      contact,
      customOrderType,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartContactSucceededAction>(
        apiCartChangeCartContactSucceededType
      ),
      failed: take<ApiCartChangeCartContactFailedAction>(apiCartChangeCartContactFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const { cart, error }: ChangeCartContactResult = succeeded.payload.result;
        if (cart === null || error !== null) {
          yield* put(
            changeCurrentCartContactFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartContactSucceeded({
              cart: convertCartToStateCart(cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartContactFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartContactSaga;
